import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import UserListTable from "../Table/UserListTable";

function MeetingUsersDialog({ onClose, open, userListData, userType }) {

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: 1, margin: 0, minHeight: 'auto', textAlign: "center" }}>
        {userType}
      </DialogTitle>
      <DialogContent dividers sx={{ padding: 0, margin: 0 }}>
        <UserListTable userList={userListData} />
      </DialogContent>
    </Dialog>

  );
}

export default MeetingUsersDialog